import { Routes } from '@angular/router';
import { Layout } from './components/layout/layout';
import { authGuard } from './guards/auth-guard';
import { auditlogResolver } from './resolvers/auditlog-resolver';
import { fallaufgabenResolver } from './resolvers/fallaufgaben.resolver';
import { fraudWarningsResolver } from './resolvers/fraud-warnings.resolver';
import { nutzerResolver } from './resolvers/nutzer-resolver';
import { retentionOverviewResolver } from './resolvers/retention-overview.resolver';
import { sessionsResolver } from './resolvers/sessions.resolver';
import { Auditlog } from './routes/auditlog/auditlog';
import { Datenaufbewahrung } from './routes/datenaufbewahrung/datenaufbewahrung';
import { FallaufgabenDetails } from './routes/fallaufgaben-details/fallaufgaben-details';
import { Fallaufgaben } from './routes/fallaufgaben/fallaufgaben';
import { CategoryInfoEditor } from './routes/kategorien/category-info/category-info';
import { Kategorien } from './routes/kategorien/kategorien';
import { SystemPrompts } from './routes/kategorien/system-prompts/system-prompts';
import { LoginComponent } from './routes/login/login.component';
import { NotFound } from './routes/not-found/not-found';
import { Nutzerverwaltung } from './routes/nutzerverwaltung/nutzerverwaltung';
import { PdfDokumente } from './routes/pdf-dokumente/pdf-dokumente';
import { FraudWarningsComponent } from './routes/fraud-warnings/fraud-warnings';

export const routes: Routes = [
  {
    path: "",
    pathMatch: "prefix",
    component: Layout,
    canActivate: [authGuard],
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "fallaufgaben"
      },
      {
        path: "fallaufgaben",
        children: [
          {
            path: "",
            pathMatch: "full",
            component: Fallaufgaben,
            resolve: {
              fallaufgabenResolver
            }
          },
          {
            path: ":fallaufgabenid",
            component: FallaufgabenDetails,
            resolve: {
              fallaufgabenResolver,
              sessionsResolver
            }
          }
        ]
      },
      {
        path: "auditlog",
        pathMatch: "full",
        component: Auditlog,
        resolve: {
          auditlogResolver
        }
      },
      {
        path: "nutzerverwaltung",
        pathMatch: "full",
        component: Nutzerverwaltung,
        resolve: {
          users: nutzerResolver
        }
      },
      {
        path: "kategorien",
        pathMatch: "full",
        component: Kategorien
      },
      {
        path: "system-prompts/:kategorie",
        pathMatch: "full",
        component: SystemPrompts
      },
      {
        path: "category-info/:kategorie",
        pathMatch: "full",
        component: CategoryInfoEditor
      },
      {
        path: "pdf-dokumente",
        pathMatch: "full",
        component: PdfDokumente
      },
      {
        path: "betrugswarnungen",
        pathMatch: "full",
        component: FraudWarningsComponent,
        resolve: {
          fraudWarningsResolver
        }
      },
      {
        path: "datenaufbewahrung",
        pathMatch: "full",
        component: Datenaufbewahrung,
        resolve: {
          retentionOverviewResolver
        }
      }
    ]
  },
  {
    path: "login",
    pathMatch: "full",
    component: LoginComponent
  },
  {
    path: "**",
    pathMatch: "full",
    component: NotFound
  }
];
